<template>
  <div>
    <h1>{{ localization[pageTitle][ctx.language] }}</h1>

    <v-form
      v-if="showForm"
      ref="form"
      v-model="validForm"
      @submit.prevent>
      <v-text-field
        id="usernameOrEmail"
        v-model="email"
        :rules="[rules.required]"
        :label="localization['Email address'][ctx.language]"
      />

      <v-text-field
        v-show="false"
        id="usernameOrEmail"
        v-model="ctx.user.username"
        :rules="[rules.required]"
        :label="localization['Username or email'][ctx.language]"/>

      <Password
        v-if="resetToken!=null"
        v-model="password"
        :confirmation="true"
        :label="localization['Password'][ctx.language]"
        :language="ctx.language"/>

      <v-btn
        id="submitButton"
        :disabled="!validForm||submitting"
        @click="submit"
      >{{ localization[buttonText][ctx.language] }}</v-btn>
    </v-form>
    <!--
    // If the reset password happend during an Auth Proceess (pollUrl exists)
    -->
    <div v-if="ctx.isAccessRequest()">
      <v-divider class="mt-3 mb-2"/>
      <router-link :to="{ name: 'Authorization' }"><h3>{{ localization['Go to Sign in'][ctx.language] }}</h3></router-link>
    </div>

    <Alerts
      :successMsg="success"
      :errorMsg="error"/>
  </div>
</template>

<script>
import Password from './bits/Password';
import Alerts from './bits/Alerts';
import Context from '../../context.js';
import controllerFactory from '../controller/controller.js';
import localization from '../../translationDict.json';

export default {
  components: {
    Password,
    Alerts,
  },
  props: {
    resetToken: {type: String, default: null},
  },
  data: () => ({
    password: '',
    error: '',
    success: '',
    showForm: true,
    submitting: false,
    ctx: {},
    c: null,
    rules: {
      required: value => !!value || 'This field is required.',
    },
    validForm: false,
    email: '',
  }),
  computed: {
    pageTitle: function () {
      return this.resetToken ? 'Set a new password' : 'Reset password';
    },
    buttonText: function () {
      return this.resetToken ? 'Change password' : 'Request password reset';
    },
  },
  watch: {
    email (newEmail) {
      this.ctx.user.username = newEmail;
    },
  },
  async created () {
    this.localization = JSON.parse(JSON.stringify(localization));
    this.ctx = new Context(this.$route.query);
    await this.ctx.init();
    this.c = controllerFactory(this.ctx);
  },
  methods: {
    submit () {
      this.ctx.user.username = this.ctx.user.username.trim();
      if (this.$refs.form.validate()) {
        this.submitting = true;
        // Ask for a reset token
        if (this.resetToken == null) {
          this.c.requestResetPassword()
            .then(() => {
              this.showForm = false;
              this.success = this.localization['Password Instructions'][this.ctx.language];
            })
            .catch(this.showError)
            .finally(() => { this.submitting = false; });
        } else {
          // If we already got a reset token, we can change the password
          this.c.resetPassword(this.password, this.resetToken)
            .then(() => {
              this.showForm = false;
              this.success = this.localization['Password change successful'][this.ctx.language];
            })
            .catch(this.showError)
            .finally(() => { this.submitting = false; });
        }
      }
    },
    showError (error) {
      this.error = error.msg;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/ResetPassword.vue